import React from "react";
import ExtLinkIcon from "../../images/footer/ext-link-icon.svg";

const ExternalLink = ({ extURL, extURLText, extStyleClass }) => (
    <a
        href={extURL}
        target="_blank"
        rel="noopener noreferrer"
        className={extStyleClass}
    >
        {extURLText}
        <img
            src={ExtLinkIcon}
            width="12"
            style={{
                marginLeft: "4px",
                verticalAlign: "middle",
                position: "relative",
                top: "-1px",
            }}
        />
    </a>
);

export default ExternalLink;

ExternalLink.defaultProps = {
    extUrl: "",
    extUrlText: "",
    extUrlText: "",
};
